<template>
    <CompassDescriptionList class="object-block__description-list" variant="frozen-field">
        <CompassDescriptionListItem
            v-if="showCompany && data.company"
            :label="$t.__('email.EmailRelatedObject.company')"
        >
            <CompassLink :label="data.company.name" :link="data.company.link" target="_blank" />
        </CompassDescriptionListItem>
        <CompassDescriptionListItem
            v-if="showContact && data.contact"
            :label="$t.__('common.labels.contact')"
        >
            <CompassLink :label="data.contact.fullName" :link="data.contact.link" target="_blank" />
        </CompassDescriptionListItem>
        <CompassDescriptionListItem
            v-if="showEmail && data.email"
            :label="$t.__('common.labels.email')"
        >
            <ContactDetails :value="data.email" variant="email" />
        </CompassDescriptionListItem>
        <CompassDescriptionListItem
            v-if="showPhone && data.phone_number"
            :label="$t.__('common.labels.phone')"
        >
            <ContactDetails :value="data.phone_number" variant="phone" />
        </CompassDescriptionListItem>
        <CompassDescriptionListItem
            v-if="showMobile && data.mobile_number"
            :label="$t.__('common.labels.mobile')"
        >
            <ContactDetails :value="data.mobile_number" variant="phone" />
        </CompassDescriptionListItem>
        <CompassDescriptionListItem
            v-if="showAddress && data.address"
            :label="$t.__('common.labels.address')"
        >
            {{ data.address.street }}<br />
            {{ data.address.postal_code }} {{ data.address.city }}
        </CompassDescriptionListItem>
    </CompassDescriptionList>
</template>
<script>
import ContactDetails from 'vcomponents/common/object/ContactDetails.vue';

export default {
    components: { ContactDetails },
    inheritAttrs: false,
    props: {
        showEmail: {
            type: Boolean,
            default: true,
        },
        showPhone: {
            type: Boolean,
            default: true,
        },
        showMobile: {
            type: Boolean,
            default: true,
        },
        showAddress: {
            type: Boolean,
            default: true,
        },
        showCompany: {
            type: Boolean,
            default: true,
        },
        showContact: {
            type: Boolean,
            default: true,
        },
        data: {
            type: Object,
            required: true,
        },
    },
};
</script>

<style lang="scss" scoped>
.object-block__description-list::v-deep {
    margin: var(--spacing-1) 0 0;

    .compass-description-list__item__content {
        align-items: center;
        display: flex;
        gap: var(--spacing-1);
    }
}
</style>
